export interface Category {
  name: string;
  url: string;
  description: string;
  imagePrompt: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Latest sneakers & footwear deals",
    imagePrompt: "Minimalist product photography of white sneakers on soft cream background with natural lighting and subtle shadows, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    description: "Cozy hoodies & sweaters collection",
    imagePrompt: "Minimalist product photography of a beige oversized hoodie laid flat on cream surface, soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    description: "Essential tees for everyday wear",
    imagePrompt: "Minimalist product photography of a white cotton t-shirt folded neatly on cream background, soft natural lighting, clean editorial style, warm tones, high detail composition"
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    description: "Trendy outerwear & jackets",
    imagePrompt: "Minimalist product photography of a light brown bomber jacket hanging on wooden hanger against cream wall, soft natural lighting, clean editorial style, warm neutral tones"
  },
  {
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    description: "Stylish bottoms for any occasion",
    imagePrompt: "Minimalist product photography of beige chino pants folded neatly on cream surface, soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    description: "Caps, hats & beanies",
    imagePrompt: "Minimalist product photography of a cream colored baseball cap on soft cream background, natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    description: "Complete outfit sets & bundles",
    imagePrompt: "Minimalist product photography of matching beige loungewear set folded on cream surface, soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    description: "Comfort essentials & basics",
    imagePrompt: "Minimalist product photography of soft cotton underwear folded on cream surface, soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    description: "Sports jerseys & athletic wear",
    imagePrompt: "Minimalist product photography of a white sports jersey laid flat on cream surface, soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    description: "Watches, jewelry & more",
    imagePrompt: "Minimalist product photography of a minimalist silver watch on cream surface with soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    description: "Backpacks, totes & handbags",
    imagePrompt: "Minimalist product photography of a beige canvas tote bag on cream surface, soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    description: "Leather belts & accessories",
    imagePrompt: "Minimalist product photography of a brown leather belt coiled on cream surface, soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    description: "Fragrances & scents collection",
    imagePrompt: "Minimalist product photography of an elegant glass perfume bottle on cream surface with soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
  {
    name: "OtherStuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    description: "More unique finds & deals",
    imagePrompt: "Minimalist product photography of assorted lifestyle items on cream surface with soft natural lighting, clean editorial style, warm neutral tones, high detail composition"
  },
];